import React from 'react';

import forwardChevronIcon from "../../../styles/img/newCheckout/right-chevron-white.svg";

const CartCTA = ({ ctaHandler }) => (
  <button className="cart-cta" type="button" onClick={ctaHandler}>
    <span>Valider et Continuer</span>
    <img src={forwardChevronIcon} alt="" />
  </button>
);

export default CartCTA;



// WEBPACK FOOTER //
// ./src/components/buy/Cart/CartCta.js